import { render, staticRenderFns } from "./FormMedecin.vue?vue&type=template&id=188b1ed4&"
import script from "./FormMedecin.vue?vue&type=script&lang=js&"
export * from "./FormMedecin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports